module.exports = "/Interessant@2x-94c86b733a15a3de0afd753bc1fc9271.png";